import React from 'react';
import { useSelector } from 'react-redux';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';

/**
 * Reads the HRL theme toggles from the @site endpoint
 * (`hrl.show_breadcrumb`, `hrl.show_heading_divider`) and applies
 * matching body classes via Volto's BodyClass helper.
 *
 * Manual `document.body.classList` manipulation cannot be used here:
 * Volto's BodyClass helper resets `document.body.className` on every
 * render, so any manually added class would be wiped on the next route
 * change.
 */
const HRLThemeSettings = () => {
  const siteData = useSelector((state) => state.site?.data);

  const showBreadcrumb = siteData?.['hrl.show_breadcrumb'] ?? true;
  const showDivider = siteData?.['hrl.show_heading_divider'] ?? true;

  const classes = [
    !showBreadcrumb && 'hrl-no-breadcrumb',
    !showDivider && 'hrl-no-heading-divider',
  ]
    .filter(Boolean)
    .join(' ');

  if (!classes) return null;

  return <BodyClass className={classes} />;
};

export default HRLThemeSettings;
